import { mainService } from '@/api/services';

import type { UnwrapData } from '../../types';

import type { ICitiesDataResponse } from './types';

export const citiesService = mainService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить список городов РФ
     */
    getCitiesData: builder.query<UnwrapData<ICitiesDataResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/cities',
      }),
      transformResponse: (response: ICitiesDataResponse): UnwrapData<ICitiesDataResponse> => response.data,
    }),
  }),
});

export const { useGetCitiesDataQuery } = citiesService;
